import { useAbility } from '@app/icare/client/auth'
import { AbilityContext } from '@pkg/auth/ability'
import type { ReactNode } from 'react'

// AbilityContext defaults to null and has no other provider; @casl/react's
// useAbility subscribes with `value.on('updated', …)`, so a null value crashes
// any consumer (e.g. useFormAction). Feed it the session-derived ability, which
// appAbilityFactory guarantees is non-null.
export function AppAbilityProvider({ children }: { children: ReactNode }) {
  const ability = useAbility()
  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
}
